var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"翻料信息","width":"800px"},on:{"close":_vm.onClose,"open":_vm.onOpen}},[_c('BlockText',{attrs:{"config":_vm.block,"detail":_vm.config.blockData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }